<mapfre-modal
  [modalOptions]="validateCustomerModalOptions"
  [hideModal]="hideModal"
  (closeModal)="resetHideModal()"
  (click)="hideOnClick($event)"
  *ngIf="!loading"
>
  <ng-container>
    <div class="modal-body eft-confirm-container-modal mt-3">
      <div class="text-center">
        <div class="modal-icon-box-center">
          <img src="./assets/img/images/profile.svg" alt="My account" />
        </div>
        <div class="autopay-title">
            {{ title | translate }}
        </div>
        <div class="autopay-modal-sub-title">
            {{ confirmInfo | translate }}                
        </div>
      </div>

      <div class="background-modal-card">
        <div class="contact-sec">
          <span class="label">{{ "EMAIL" | translate }}: </span>
          <span class="value">{{ email }}</span>
        </div>
      
        <div class="contact-sec" *ngIf="phone?.number">
          <span class="label">{{ "PHONE" | translate }}: </span>
          <span class="value">{{ phone?.number }}</span>
        </div>             
      </div>
      <hr class="margin-bottom mb24 mt-4 hr-profile" />
        <div class="confirm-action-sec">
          <mapfre-button
            (click)="gotoManageContact()"
            additionalClasses="ghost secondary small-btn modal-small-btn"
            >{{ "UPDATE_PROFILE" | translate }}
          </mapfre-button>
          <mapfre-button
            (click)="cancelModal(true)"
            additionalClasses="basic primary small-btn modal-small-btn"
            >{{ "LOOKS_GOOD" | translate }}
          </mapfre-button>          
        </div>
    </div>
  </ng-container>
</mapfre-modal>
